import React from 'react';
import { observer } from 'mobx-react-lite';
import { roomStore } from '../stores/roomStore';
import Button from '../components/button';
import { appService } from '../services/appService';
import { appSyncStore } from '../stores/appSyncStore';
import { async, utils } from '../utils/common';
import QrCodeModal from '../components/qrCodeModal';
import { svgIcons } from '../svgIcons';
import { appLocalStore } from '../stores/appLocalStore';
import { AppPage } from '../components/appPage';

const Waiting: React.FC = observer(() => {

  const waitingPageStore = appLocalStore.pages.waiting;

  const handleCopyCode = async () => {
    if (roomStore.joinCode) {
      try {
        await navigator.clipboard.writeText(roomStore.joinCode);
        waitingPageStore.action(_ => _.copyToClipboardClicked = true);
        await async.waitSecondsAsync(2);
        waitingPageStore.action(_ => _.copyToClipboardClicked = false);
      } catch (error) {
        console.error('Failed to copy join code:', error);
      }
    }
  };

  const getQrCodeUrl = () => {
    return `${window.location.origin}#join=${roomStore.joinCode}`;
  };

  const handleBack = () => {
    appService.leaveWaitingRoom();
  };

  const handleDisconnectParticipant = (userId: string) => {
    appService.disconnectParticipant(userId);
  };

  return (
    <AppPage className="app--bgBlack"
      headerClassName="app--bgBlack pb-4"
      header={
        <>
          <h1 className="text-[var(--text-primary)] text-3xl font-bold m-0 mb-4 text-center">Waiting Room</h1>
          <div className="flex flex-col items-center gap-2 mb-4">
            <span className="text-[var(--text-secondary)] text-sm">Join Code:</span>
            <div className="flex items-center gap-3">
              <button
                className="bg-[var(--bg-secondary)] border-none p-3 rounded-lg cursor-pointer flex items-center justify-center text-indigo-600 transition-all hover:bg-[var(--border-color)] hover:scale-105 active:scale-95"
                onClick={handleCopyCode}
                title="Copy Join Code"
                aria-label="Copy Join Code"
              >
                {waitingPageStore.copyToClipboardClicked ? <svgIcons.checkmark /> : <svgIcons.clipboard />}
              </button>
              <div className="bg-[var(--bg-secondary)] px-6 py-3 rounded-lg text-2xl font-bold tracking-[0.25rem] text-indigo-600 transition-colors">
                {roomStore.joinCode}
              </div>
              <button
                className="bg-[var(--bg-secondary)] border-none p-3 rounded-lg cursor-pointer flex items-center justify-center text-indigo-600 transition-all hover:bg-[var(--border-color)] hover:scale-105 active:scale-95"
                onClick={() => waitingPageStore.action(_ => _.showQrModal = true)}
                title="Show QR Code"
                aria-label="Show QR Code"
              >
                <svgIcons.qrCode />
              </button>
            </div>
              
          </div>
          <h2 className="text-[var(--text-primary)] text-xl m-0 text-center">Players ({appSyncStore.users.size})</h2>
              
        </>
      }
      contentScrollable={true}
      content={
        <>

           
              <div className="mx-5">

                {Array.from(appSyncStore.users.values()).map((user) => (
                  <div key={user.id} className="flex items-center gap-3 p-3 mb-2 bg-[var(--bg-secondary)] rounded-md transition-colors last:mb-0 hover:bg-[var(--border-color)]">
                    {user.avatar && (
                      <img
                        src={user.avatar}
                        alt={`${user.name}'s profile`}
                        className="w-10 h-10 rounded-full object-cover border-2 border-indigo-600"
                      />
                    )}
                    <span className="text-[var(--text-primary)] text-base font-medium flex-1">{user.name}</span>
                    {user.isHost ? (
                      <span className="bg-blue-600 text-white px-3 py-1 rounded-xl text-xs font-semibold uppercase">Host</span>
                    ) : (
                      appLocalStore.isHost && (
                        <button
                          className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg transition-colors flex items-center justify-center"
                          onClick={() => handleDisconnectParticipant(user.id)}
                          title="Disconnect player"
                          aria-label={`Disconnect ${user.name}`}
                        >
                          <svgIcons.xIcon />
                        </button>
                      )
                    )}
                  </div>
                ))}
              </div>
            
        

          {waitingPageStore.showQrModal && (
            <QrCodeModal
              url={getQrCodeUrl()}
              onClose={() => waitingPageStore.action(_ => _.showQrModal = false)}
            />
          )}
        </>
      }
      footerClassName="app--bgBlack"
      footer={
        <>
          {appLocalStore.isHost && (
            <div className="mt-2">
              <Button
                onClick={appService.startGameOnHost}
                fullWidth
                disabled={!appSyncStore.canStartGame}
              >
                Start Game
              </Button>
            </div>
          )}

          {!appLocalStore.isHost && (
            <div className="mt-6 text-center">
              <p className="text-[var(--text-secondary)] text-lg">Waiting for host to start game...</p>
            </div>
          )}

          <div className="mt-4">
            <Button
              onClick={handleBack}
              fullWidth
              variant="secondary"
            >
              Back
            </Button>
          </div>
        </>
      }
    />
  );
});

export default Waiting;
